import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { SaveForm } from '@tokeet/tv3-platform'
import { SearchService } from '@tv3/store/search/search.service'
import { BehaviorSubject } from 'rxjs'
import { distinctUntilChanged } from 'rxjs/operators'
import * as lodash from 'lodash'
import { MatDialogRef } from '@angular/material/dialog'

export interface SelectItemDialogConfig {
  title: string
  help: string
}

@Component({
  selector: 'app-select-item-dialog',
  templateUrl: './select-inquiry-dialog.component.html',
  styleUrls: ['./select-inquiry-dialog.component.scss'],
  host: { class: 'modal-content' },
})
export class SelectInquiryDialogComponent implements OnInit {
  config = {
    title: 'Select Inquiry',
    help: 'Please select one inquiry from the list above for the copied invoice.',
  } as SelectItemDialogConfig

  form = this.fb.group({
    selected: [undefined, [Validators.required]],
  })

  search = new BehaviorSubject<string>('')
  inquiries$ = this.searchService.getInquiries(this.search).pipe(
    distinctUntilChanged((a, b) => {
      const ids1 = lodash.map(a, 'id')
      const ids2 = lodash.map(b, 'id')

      return !lodash.difference(ids1, ids2).length && !lodash.difference(ids2, ids1).length
    })
  )

  constructor(
    public dialogRef: MatDialogRef<SelectInquiryDialogComponent>,
    private fb: FormBuilder,
    protected searchService: SearchService
  ) {}

  ngOnInit() {}

  close() {
    this.dialogRef.close()
  }

  @SaveForm()
  save(form: FormGroup) {
    const formValues = form.getRawValue()
    this.dialogRef.close(formValues.selected)
  }
}
